import React, { useState, useRef } from "react";
import {
  Button,
  Flex,
  FormControl,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner, 
  Text,
  useToast // Importe o hook useToast do Chakra UI
} from "@chakra-ui/react";
import Login from "../../../services/loginApi";
import { ModalHeader as ChakraModalHeader } from "@chakra-ui/react";

const ModalSendACodeToLogin = ({
  isOpen,
  setIsOpen,
  email,
  type,
}: any) => {
  const [codes, setCodes] = useState<string[]>(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputsRef = useRef<HTMLInputElement[]>([]);
  const finalRef = useRef(null);
  const toast = useToast(); // Inicialize o hook useToast

  const handleChange = (index: number, value: string) => {
    const newCodes = [...codes];
    newCodes[index] = value.replace(/\D/g, "").slice(0, 1);
    setCodes(newCodes);

    if (value && index < codes.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && !codes[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const paste: any = event.clipboardData.getData('text').slice(0, 6); // Limita ao tamanho dos inputs
    const newCodes: any = [...paste].map((char) => char.replace(/\D/g, ""));
    setCodes(newCodes);

    newCodes.forEach((value: any, index: any) => {
      if (inputsRef.current[index]) {
        inputsRef.current[index].value = value;
      }
    });

    // Foca no próximo input após o último preenchido
    const nextIndex = paste.length < 6 ? paste.length : 5;
    if (inputsRef.current[nextIndex]) {
      inputsRef.current[nextIndex].focus();
    }
  };

  const handleSubmit = async () => {
    const code = codes.join("");
    console.log("code", code);

    try {
      setLoading(true); // Ativa o estado de carregamento
      const response = await Login.ValidateResetPasswordCode(email, "resetsenha", code); // Corrigido para enviar "resetsenha" como tipo
      
      setIsOpen(false);

      // Exiba a mensagem de sucesso ao lado da tela
      const successMessage =
        "Código de verificação confirmado. Você recebera próxima instruções em breve.";
      toast({
        title: "Código verificado com sucesso!",
        description: successMessage,
        status: "success",
        duration: 5000, 
        isClosable: true, 
        position: "top-right",
      });
   
    } catch (error) {
      // Verifica se o erro é uma instância de Error e se possui a propriedade 'message'
      const errorMessage = error instanceof Error ? error.message : "Erro ao verificar código de verificação.";
      
      toast({
        title: "Erro ao verificar o código de verificação!",
        description: errorMessage,
        status: "error",
        duration: 5000, 
        isClosable: true, 
        position: "top-right", 
      });
    } finally {
      setLoading(false); 
    }
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ChakraModalHeader>
            <Flex w={"100%"} justifyContent={"center"} my={2}>
              <Text fontSize={"xl"} fontWeight={"bold"}>
                Digite seu código de verificação
              </Text>
            </Flex>
          </ChakraModalHeader>
          <ModalBody>
            <Flex w={"100%"} justifyContent={"center"}>
              {codes.map((value, index) => (
                <Input
                  key={index}
                  ref={(el) => (inputsRef.current[index] = el as HTMLInputElement)}
                  type="text"
                  maxLength={1}
                  width="3rem"
                  textAlign="center"
                  value={value}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  marginRight={2}
                />
              ))}
            </Flex>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              mt={4}
              onClick={handleSubmit}
              disabled={codes.some((code) => !code) || loading} 
            >
              {loading ? ( 
                <Spinner size="sm" color="white" />
              ) : (
                "Confirmar código"
              )}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalSendACodeToLogin;
